import React from 'react';
import Reveal from '../primitives/Reveal';

interface IncludedListProps {
  items: string[];
}

/** What membership includes, one line per hairline row, read from the service catalogue. */
export default function IncludedList({ items }: IncludedListProps) {
  return (
    <Reveal>
      <ul className="mk-included">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </Reveal>
  );
}
